import React, { FunctionComponent } from 'react';

import './ProjectMainSection.scss';

import MainSectionVideo from './MainSectionVideo/MainSectionVideo';
import MainSectionFooter from './MainSectionFooter/MainSectionFooter';
import { Peer, Peers } from '../../types/SignalR';
import MainSectionHeader from './MainSectionHeader/MainSectionHeader';

type MainSectionProps = {
  isProducer: boolean;
  token?: string;
  sendRequestControlCallback: () => void;
  sendTakeControlCallback: () => void;
  sendGiveControlCallback: () => void;
  getPeerInfoCallback: (peerId: string) => Peer | null;
  peerRequestingControl: Peer | null;
  connectedPeers: Peers;
  isAwaitingApiSaveToComplete: boolean;
  isUserActiveCallback: (userId: string) => boolean;
  isUserLiveCallback: (userId: string) => boolean;
  myConnectionIsLive: boolean;
};

const ProjectMainSection: FunctionComponent<MainSectionProps> = (props) => {
  return (
    <div className="project-main-section">
      <MainSectionHeader {...props} />
      <div className="columns signer-main-section">
        <MainSectionVideo
          isAwaitingApiSaveToComplete={props.isAwaitingApiSaveToComplete}
          userType={props.getPeerInfoCallback(props.token || '')?.userType}
        />
      </div>
      <MainSectionFooter {...props} sendTakeControlCallback={props.sendTakeControlCallback} />
    </div>
  );
};

export default ProjectMainSection;
